import { NavItem, NavGroup } from '../../docs/constants/routeMap';

import Guide from 'plaid-threads/Icons/Guide';
import Help from 'plaid-threads/Icons/Help';
import Home from 'plaid-threads/Icons/Home';
import Changelog from 'plaid-threads/Icons/Changelog';
import Terminal from 'plaid-threads/Icons/Terminal';
import Book from 'plaid-threads/Icons/Book';
import Build from 'plaid-threads/Icons/Build';
import Key from 'plaid-threads/Icons/Key';
import Clipboard from 'plaid-threads/Icons/Clipboard';
import User from 'plaid-threads/Icons/User';
import List from 'plaid-threads/Icons/List';
import Products from 'plaid-threads/Icons/Products';
import Rocket from 'plaid-threads/Icons/Rocket';
import Shield from 'plaid-threads/Icons/Shield';
import Gear from 'plaid-threads/Icons/Gear';
import Lightbulb from 'plaid-threads/Icons/Lightbulb';

export const API_REFERENCE: NavGroup = [
  {
    children: [
      {
        title: 'v6.4',
        path: '/reference/6.4',
      },
      {
        title: 'v6.3',
        path: '/reference/6.3',
      },
      {
        title: 'v6.2',
        path: '/reference/6.2',
      },
      {
        title: 'v6.1',
        path: '/reference/6.1',
      },
      {
        title: 'v6.0',
        path: '/reference/6.0',
      },
      {
        title: 'v5.3',
        path: '/reference/5.3',
      },
      {
        title: 'v5.2',
        path: '/reference/5.2',
      },
      {
        title: 'v5.1',
        path: '/reference/5.1',
      },
      {
        title: 'v5.0',
        path: '/reference/5.0',
      },
      {
        title: 'v4.6',
        path: '/reference/4.6',
      },
    ],
  },
];

export const AUTH_GUIDE: NavGroup = [
  {
    children: [
      {
        title: 'Planning your integration',
        path: '/authentication/planning',
      },
      {
        title: 'OAuth server setup',
        path: '/authentication/oauth-server-setup',
      },
      {
        title: 'Implementing the OAuth flow',
        path: '/authentication/oauth-flow',
      },
      {
        title: 'App2App',
        path: '/authentication/app2app',
      },
      {
        title: 'Supporting non-Plaid traffic',
        path: '/authentication/supporting-non-plaid-traffic',
      },
    ],
  },
];

const GETTING_STARTED: NavGroup = [
  {
    title: 'Getting started',
    icon: Rocket,
    children: [
      {
        title: 'Welcome',
        path: '/',
        icon: Home,
        highlight: true,
        subNav: false,
      },
      {
        title: 'Onboarding guide',
        path: '/onboarding-guide',
        icon: Rocket,
        highlight: true,
      },
      {
        title: 'Implementation checklist',
        path: '/implementation-checklist',
        icon: Clipboard,
        highlight: true,
      },
    ],
  },
];

const SETUP: NavGroup = [
  {
    title: 'Setup & configuration',
    icon: Gear,
    children: [
      {
        title: 'Dashboard overview',
        path: '/dashboard-overview',
        icon: Products,
        highlight: true,
      },
      {
        title: 'Testing & validation',
        path: '/testing',
        icon: Lightbulb,
        highlight: true,
      },
      {
        title: 'Production access',
        path: '/production-access',
        icon: Gear,
        highlight: true,
      },
    ],
  },
];

const BUILDING: NavGroup = [
  {
    title: 'Building your integration',
    icon: Build,
    children: [
      {
        title: 'Authentication',
        path: '/authentication',
        icon: Key,
        children: AUTH_GUIDE,
      },
      {
        title: 'User experience',
        path: '/user-experience',
        icon: User,
      },
      {
        title: 'Security best practices',
        path: '/security',
        icon: Shield,
      },
      {
        title: 'Mock server',
        path: '/mock-server',
        icon: Terminal,
      },
    ],
  },
];

const POST_LAUNCH: NavGroup = [
  {
    title: 'Post-launch',
    icon: Lightbulb,
    children: [
      {
        title: 'Post-launch operations',
        path: '/post-launch',
        icon: Products,
        highlight: true,
      },
      {
        title: 'Dashboard monitoring',
        path: '/post-launch/dashboard',
        icon: Products,
        highlight: true,
      },
      {
        title: 'Data Partner MCP',
        path: '/data-partner-mcp',
        icon: Terminal,
        highlight: true,
      },
      {
        title: 'Consent management',
        path: '/consent-management',
        icon: Clipboard,
        children: [
          {
            title: 'Permissions Manager API',
            path: '/consent-management/permissions-manager',
            icon: List,
          },
          {
            title: 'Consent API',
            path: '/consent-management/api',
            icon: List,
          },
        ],
      },
      {
        title: 'App Directory',
        path: '/permissions-manager',
        icon: User,
        highlight: true,
        children: [
          {
            title: 'App Directory API',
            path: '/permissions-manager/app-directory',
            icon: List,
          },
        ],
      },
      {
        title: 'Troubleshooting',
        path: '/troubleshooting',
        icon: Help,
      },
    ],
  },
];

const REFERENCE: NavGroup = [
  {
    title: 'Reference',
    icon: Book,
    children: [
      {
        title: 'API reference',
        path: '/reference',
        icon: Guide,
        children: API_REFERENCE,
      },
      {
        title: 'Changelog',
        path: '/changelog',
        icon: Changelog,
        highlight: true,
      },
      {
        title: 'Migrating from earlier Core Exchange versions',
        path: '/migration-guide',
        icon: Rocket,
        highlight: true,
      },
      {
        title: 'Data mapping guide',
        path: '/data-mapping-guide',
        icon: Help,
        highlight: true,
      },
      {
        title: 'Migrating from Plaid Exchange',
        path: '/migrating-from-plaid-exchange',
        icon: Rocket,
        highlight: true,
        children: [
          {
            title: 'Backend token exchange',
            path: '/migrating-from-plaid-exchange/backend-token-exchange',
            icon: Key,
          },
        ],
      },
    ],
  },
];

export const ROUTES: NavGroup = [
  ...GETTING_STARTED,
  ...SETUP,
  ...BUILDING,
  ...POST_LAUNCH,
  ...REFERENCE,
];

// everything
export const ROUTE_MAP: NavGroup = [...ROUTES];

const flattenNavGroup = (group: NavGroup): Array<NavItem> =>
  group.reduce((acc, item) => {
    const res: Array<NavItem> = [];
    // if this item has properties,
    // push item to results
    if (item.path != null && item.title != null) {
      res.push(item);
    }
    // process children if they exist
    if (item.children != null) {
      res.push(...flattenNavGroup(item.children));
    }
    return acc.concat(res);
  }, []);

export const ROUTE_MAP_FLAT = flattenNavGroup(ROUTE_MAP);
